/*
上の帯の「続きから」の行き先。ダッシュボードの「次の講座」(DashboardShape の next) と同じ値を、
トップを開いたときに端末へ控える。帯は luagate 配下の全ページに出るので、全ページの loader に
学習の集計を足さずに済ませるため (resume-point と同じ考え方)。
*/
const STORAGE_KEY = "luagate_continue";
export const CONTINUE_EVENT = "luagate:continue-updated";

export type ContinuePoint = {
  courseTitle: string;
  lessonTitle: string;
  href: string;
  /** 学習パスの「5-9」の形の番号。帯の札はこれだけを出す (切って「…」を付けた題名は出さない)。コースの項目など番号が無い物は省く */
  number?: string | null;
};

function isContinuePoint(value: unknown): value is ContinuePoint {
  if (typeof value !== "object" || value === null) return false;
  const v = value as Record<string, unknown>;
  return (
    typeof v.courseTitle === "string" &&
    typeof v.lessonTitle === "string" &&
    typeof v.href === "string" &&
    v.href.startsWith("/") &&
    (v.number === undefined || v.number === null || typeof v.number === "string")
  );
}

/** 値が無い (null) ときは控えを消す。次の講座が無い人に古い行き先を出さない */
export function saveContinuePoint(point: ContinuePoint | null): void {
  if (typeof window === "undefined") return;
  try {
    if (point) window.localStorage.setItem(STORAGE_KEY, JSON.stringify(point));
    else window.localStorage.removeItem(STORAGE_KEY);
    window.dispatchEvent(new Event(CONTINUE_EVENT));
  } catch {
    // localStorage が使えない環境では黙って諦める
  }
}

export function readContinuePoint(): ContinuePoint | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed: unknown = JSON.parse(raw);
    return isContinuePoint(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export const CONTINUE_STORAGE_KEY = STORAGE_KEY;

/** 体験の期限までの日数 (切り上げ)。期限が無い、読めないときは null */
export function trialDaysLeftFrom(expiresAt: string | null | undefined, nowMs: number): number | null {
  if (!expiresAt) return null;
  const diff = new Date(expiresAt).getTime() - nowMs;
  if (!Number.isFinite(diff)) return null;
  return Math.max(0, Math.ceil(diff / 86_400_000));
}
